import { minutesToHours } from '@/helpers/date-format';

import { parseTimeInputToMinutes } from './time-input-parser.helper';

/** A single day's approved time can't exceed 24 hours. */
export const MAX_APPROVED_HOURS = 24;

export const APPROVED_INVALID_FORMAT_KEY =
  'authenticated.timeTracking:approvals.columns.approvedInvalidFormat';
export const APPROVED_EXCEEDS_MAX_KEY =
  'authenticated.timeTracking:approvals.columns.approvedExceedsMax';

export interface ApprovedHoursValidationResult {
  /** i18n key of the validation message, or null when the input is valid. */
  errorKey: string | null;
  /** Parsed decimal hours, or null when the input is unparseable. */
  parsedHours: number | null;
}

/**
 * Validate the free-form approved-duration input (e.g. `3h 30m`, `600m`, `1.5`,
 * `2:30`). Shared by the cell's live onChange check and its onBlur commit.
 */
export function validateApprovedInput(raw: string): ApprovedHoursValidationResult {
  // Approving 0h 0m is valid (approve none of the tracked time), so allow a zero
  // duration here — unlike time-entry creation which requires a positive duration.
  const minutes = parseTimeInputToMinutes(raw, { allowZero: true });
  const parsedHours = minutes !== null ? minutesToHours(minutes) : null;

  if (parsedHours === null) {
    return { errorKey: APPROVED_INVALID_FORMAT_KEY, parsedHours: null };
  }
  if (parsedHours > MAX_APPROVED_HOURS) {
    return { errorKey: APPROVED_EXCEEDS_MAX_KEY, parsedHours };
  }
  return { errorKey: null, parsedHours };
}
